import React from 'react';
import PropTypes from 'prop-types';
import styles from '../searchV2.scss';

const FilterDropdown = ({
    title,
    children,
    onCloseClick,
    handleFilterSubmit,
    showClearButton = true,
    showHeader = true,
    submitButtonText = 'Apply',
    clearButtonText = 'Cancel',
    'data-testid': dataTestId,
}) => {
    return (
        <div className={styles.filterDropdown}>
            {showHeader && (
                <div className={styles.filterDropdownHeader}>
                    <h3 className={styles.filterDropdownTitle} data-testid={dataTestId && `${dataTestId}.title`}>{title}</h3>
                    <button
                        type="button"
                        className={styles.filterDropdownClose}
                        onClick={onCloseClick}
                        aria-label="Close"
                        data-testid={dataTestId && `${dataTestId}.header.close-btn`}
                    >
                        <img src="/img/v2/icons/icon-close.svg" alt="Close" data-testid={dataTestId && `${dataTestId}.header.close-icon`} />
                    </button>
                </div>
            )}

            <div className={styles.filterDropdownContent}>
                {children}
            </div>

            <div className={styles.filterDropdownFooter}>
                <button
                    type="button"
                    className={styles.applyButton}
                    onClick={handleFilterSubmit}
                    data-testid={dataTestId && `${dataTestId}.apply-btn`}
                >
                    {submitButtonText}
                </button>
                {showClearButton && (
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={onCloseClick}
                        data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                    >
                        {clearButtonText}
                    </button>
                )}
            </div>
        </div>
    );
};

FilterDropdown.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    showClearButton: PropTypes.bool,
    showHeader: PropTypes.bool,
    submitButtonText: PropTypes.string,
    clearButtonText: PropTypes.string,
    'data-testid': PropTypes.string,
};

FilterDropdown.defaultProps = {
    title: '',
    showClearButton: true,
    showHeader: true,
    submitButtonText: 'Apply',
    clearButtonText: 'Cancel',
    'data-testid': null,
};
export default FilterDropdown;
